<template>
  <q-card
    class="rounded-xl border border-neutral-100/5 backdrop-blur-lg shadow-none flex flex-col"
  >
    <div class="flex justify-between gap-8 p-16 !pb-12 flex-1">
      <div class="flex-1 space-y-4 flex flex-col md2:justify-between">
        <span
          class="text-caps-2 text-neutral-70 line-clamp-1 md2:line-clamp-2"
        >
          {{ title }}
        </span>

        <h2 class="text-title-2 text-primary-pure">
          {{ value }}
        </h2>
      </div>

      <q-icon
        :name="`svguse:#${icon}`"
        size="1.5rem"
        class="text-primary-pure text-[1.5rem]"
      />
    </div>

    <span
      class="h-1 bg-[linear-gradient(90deg,rgba(23,24,25,0.05)0%,rgba(23,24,25,0)100%)] w-full block"
    />
    <div class="p-16 !pt-12">
      <p
        class="text-paragraph-4 text-neutral-70 line-clamp-1 cursor-pointer"
      >
        {{ subtitle }}

        <q-tooltip
          anchor="top middle"
          self="bottom middle"
          :offset="[0, 10]"
          class="text-paragraph-4"
        >
          {{ subtitle }}
        </q-tooltip>
      </p>
    </div>
  </q-card>
</template>

<script setup>
defineProps({
  index: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
})
</script>

<style lang="scss" scoped></style>
